'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = promiseMiddleware;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // require('es6-promise').polyfill();


var instance = _axios2.default.create({
    baseURL: process.env.NODE_ENV === 'production' ? '//localhost:8080/' : '',
    withCredentials: process.env.NODE_ENV === 'production'
});

instance.defaults.timeout = 60000;

function promiseMiddleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;

    return function (next) {
        return function (action) {

            if (typeof action === 'function') {
                return action(dispatch, getState);
            }

            var promise = action.promise,
                types = action.types,
                afterSuccess = action.afterSuccess,
                afterFail = action.afterFail,
                rest = _objectWithoutProperties(action, ['promise', 'types', 'afterSuccess', 'afterFail']);

            if (!action.promise) {
                return next(action);
            }

            var REQUEST = types[0],
                SUCCESS = types[1],
                FAILURE = types[2];

            next(_extends({}, rest, {
                type: REQUEST
            }));

            var onFulfilled = function onFulfilled(result) {
                next(_extends({}, rest, {
                    result: result,
                    type: SUCCESS
                }));
                if (afterSuccess) {
                    afterSuccess(dispatch, getState, result);
                }
            };
            var onRejected = function onRejected(error) {
                next(_extends({}, rest, {
                    error: error,
                    type: FAILURE
                }));
                if (afterFail) {
                    afterFail(dispatch, getState, error);
                }
            };
            return promise(instance).then(onFulfilled, onRejected).catch(function (error) {
                console.error('MIDDLEWARE ERROR:', error);
                onRejected(error);
            });
        };
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/config/promiseMiddleware.js
// module id = 504
// module chunks = 0